import { ValiError } from 'valibot'

// SSR awaits suspense(), so retry backoff would hold the Lambda response; the client keeps retrying.
export function createQueryRetry(isServer: boolean) {
  return (failureCount: number, error: unknown): boolean => {
    if (isServer || error instanceof ValiError || error instanceof NotFoundError || isFetchError(error, 404)) {
      return false
    }

    return failureCount < 3
  }
}
